import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { AppConfig } from '../config';
import { map, tap } from 'rxjs/operators';
import { Utils } from '../helpers/utils';
import { MessageService } from 'primeng/api';
import * as moment from 'moment';

import {
  ClientStatementLineItemModel,
  PatientResponsibilityAccountModel,
  PaymentPlanViewModel,
  PaymentPlanModel,
  FinancialAgreementAllowedPaymentPlanViewModel,
  PaymentPlanScheduleViewModel
} from '../../models/PatientResponsibilityAccount';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class PatientResponsibilityAccountsService {


  
  clientStatementLineItems: ClientStatementLineItemModel[];
  accounts: PatientResponsibilityAccountModel[];
  $accounts = new Subject<PatientResponsibilityAccountModel[]>();
  
  $clientStatementLineItems = new Subject<ClientStatementLineItemModel[]>();


  constructor(private http: HttpClient,
    private messageService: MessageService) { }
  
  getAccounts() {
    return this.http.get<PatientResponsibilityAccountModel[]>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts`)
      .pipe(tap(accounts => {
        if (accounts) {
          console.debug(accounts.length + ' Accounts loaded');
          this.accounts = accounts;
          this.$accounts.next(accounts);
        }
        return accounts;
      },
        error => {
          console.log(error);
          this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
        }));
  }



  /**
     * Updates the account 
     *
     * @param model
     */
  updateAccount(model: PatientResponsibilityAccountModel) {

    var currentAccount = this.accounts.find(a => a.patientResponsibilityAccountID == model.patientResponsibilityAccountID) || {};
    const data: PatientResponsibilityAccountModel = {
      ...currentAccount,
      ...model
    };
    return this.http.put<any>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${model.patientResponsibilityAccountID}`,
      data).pipe(
        tap(
          data => {
            

          },
          error => {
            console.log(error);
            this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
          }
        )
      );;
  }


  public getPaymentPlans(patientResponsibilityAccountID: number, onlyScheduled?: boolean) {

    let params = new HttpParams(); //.set("patientResponsibilityAccountID", patientResponsibilityAccountID.toString());
    if (onlyScheduled !== null && onlyScheduled !== undefined)
      params = params.set("onlyScheduled", onlyScheduled.toString());
    if (!patientResponsibilityAccountID)
      patientResponsibilityAccountID = 0;


    return this.http.get<PaymentPlanViewModel[]>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/PaymentPlans`, { params: params })
      .pipe(tap(paymentPlans => {
        return paymentPlans;
      },
        error => {
          console.log(error);
          this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
        }));
  }

  updatePaymentPlan(patientResponsibilityAccountID: number, model: PaymentPlanModel) {

    
    return this.http.put<any>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/PaymentPlan`,
      model).pipe(
        tap(
          data => {


          },
          error => {
            console.log(error);
            this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
          }
        )
      );;
  }



  public getAllowedPaymentPlanOptions(patientResponsibilityAccountID: number) {
    return this.http.get<FinancialAgreementAllowedPaymentPlanViewModel[]>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/PaymentPlanOptions`)
      .pipe(tap(paymentPlanOptions => {
        return paymentPlanOptions;
      },
        error => {
          console.log(error);
          this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
        }));
  }
  public getPatientStatement(patientResponsibilityAccountID: number, startDate?: Date, endDate?: Date): Observable<ClientStatementLineItemModel[]> {
    
    let params = new HttpParams();//.set("patientResponsibilityAccountID", patientResponsibilityAccountID.toString());
    if (startDate !==null)
      params = params.set("startDate", moment(startDate).format('YYYY-MM-DD')); 
    if (endDate !==null)
      params = params.set("endDate", moment(endDate).format('YYYY-MM-DD')); 

    return this.http.get<ClientStatementLineItemModel[]>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/Statement`, { params: params } )
      .pipe(tap(clientStatementLineItems => {
        if (clientStatementLineItems) {
          console.debug(clientStatementLineItems.length + ' client statement line items loaded');
          this.clientStatementLineItems = clientStatementLineItems;
          this.$clientStatementLineItems.next(clientStatementLineItems);
        }
        return clientStatementLineItems;
      },
        error => {
          console.log(error);
          this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
        }));

  }

   
  public getPatientStatementPDF(patientResponsibilityAccountID?: number, startDate?: Date, endDate?: Date) {

    let params = new HttpParams(); //.set("patientResponsibilityAccountID", patientResponsibilityAccountID.toString());
    if (startDate !== null)
      params = params.set("startDate", moment(startDate).format('YYYY-MM-DD'));
    if (endDate !== null)
      params = params.set("endDate", moment(endDate).format('YYYY-MM-DD'));

    return this.http.get(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/StatementDownload`,
      {
        params: params,
        responseType: 'arraybuffer',
        observe: 'response'
      });
  }



  public getPaymentSchedule(patientResponsibilityAccountID?: number, paymentPlanID?: number) {
    let params = new HttpParams(); //.set("patientResponsibilityAccountID", patientResponsibilityAccountID.toString());
    if (paymentPlanID)
      params = params.set("paymentPlanID", paymentPlanID.toString());
    if (!patientResponsibilityAccountID)
      patientResponsibilityAccountID = 0;


    return this.http.get<PaymentPlanScheduleViewModel[]>(`${AppConfig.settings.apiServer.webApiURL}/PatientResponsibilityAccounts/${patientResponsibilityAccountID}/PaymentSchedule`, { params: params })
      .pipe(tap(items => {
        return items;
      },
        error => {
          console.log(error);
          this.messageService.add({ severity: 'error', detail: 'Internal Error: ' + (error.message || error) });
        }));
  }
}
